var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientCaption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.3935 43.5C45.4725 43.5 36.5845 52.02 36.5469 62.5061H39.2073H42.48H53.1031L53.1145 56.5645H44.0373C46.3526 52.3409 51.0156 49.4417 56.3935 49.4417C61.7717 49.4417 66.4348 52.3409 68.75 56.5645H59.7049L59.6935 62.5061H70.3073H70.8413H76.2405C76.2027 52.02 67.3149 43.5 56.3935 43.5Z",
    fill: "#587E85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3529 39.6484C14.2654 39.6484 3.63021 49.9178 3.73514 62.5019C3.73681 62.5036 3.73774 62.5045 3.73941 62.506H6.05714H9.67081H24.0589L24.0704 56.5644H10.7438C13.2293 50.1665 19.7366 45.5901 27.3529 45.5901C34.9691 45.5901 41.4764 50.1665 43.9619 56.5644H30.6608L30.6492 62.506H45.0349H49.5535H50.9663C50.9679 62.5045 50.9689 62.5036 50.9705 62.5019C51.0755 49.9178 40.4403 39.6484 27.3529 39.6484Z",
    fill: "#587E85"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5485 45.5886C19.4834 45.5886 12.9219 39.2814 12.9219 31.5287C12.9219 23.776 19.4833 17.4688 27.5485 17.4688C35.6135 17.4688 42.1751 23.776 42.1751 31.5287C42.1751 39.2814 35.6135 45.5886 27.5485 45.5886ZM27.5485 23.4104C22.7595 23.4104 18.8635 27.0521 18.8635 31.5287C18.8635 36.0052 22.7595 39.6469 27.5485 39.6469C32.3374 39.6469 36.2334 36.0052 36.2334 31.5287C36.2334 27.0521 32.3374 23.4104 27.5485 23.4104Z",
    fill: "#A9CF3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1084 49.4382C50.2164 49.4382 44.6094 44.0391 44.6094 37.4027C44.6094 30.7663 50.2164 25.3672 57.1084 25.3672C64.0001 25.3672 69.6072 30.7663 69.6072 37.4027C69.6072 44.0391 64.0001 49.4382 57.1084 49.4382ZM57.1084 31.3089C53.4926 31.3089 50.551 34.0425 50.551 37.4027C50.551 40.7629 53.4926 43.4965 57.1084 43.4965C60.724 43.4965 63.6655 40.7629 63.6655 37.4027C63.6656 34.0425 60.724 31.3089 57.1084 31.3089Z",
    fill: "#A9CF3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientCaption);
export default __webpack_public_path__ + "static/media/patient-caption.3a06460e797828a5e73fd00c0bde26aa.svg";
export { ForwardRef as ReactComponent };